'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _flora = require('./flora.service');

var _flora2 = _interopRequireDefault(_flora);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var floraModule = _angular2.default.module('flora.service', []).service('Flora', _flora2.default).name;

exports.default = floraModule;


// WEBPACK FOOTER //
// ./client/app/services/floraService/flora.js